import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { SwiperSlide } from 'swiper/react';
import { Heading } from 'yoso';
import { breakpoints } from '~/components/Breakpoint/Breakpoint.hook';
import { BaseCard } from '~/components/Card';
import cardStyles from '~/components/Card/Description/DescriptionCard.module.scss';
import { Carousel, CarouselProps } from '~/components/Carousel';
import { T } from '~/components/I18n';
import basket from '~/components/Icon/basket.png';
import coneHat from '~/components/Icon/coneHat.png';
import rocket from '~/components/Icon/rocket.png';
import styles from './HowToCollect.module.scss';

const defaultCarouselProps: CarouselProps = {
  breakpoints: {
    0: {
      slidesPerView: 'auto',
      spaceBetween: 10,
    },
    [breakpoints.medium]: {
      slidesPerView: 3,
      spaceBetween: 21,
    },
  },
  shadow: true,
};

export const HowToCollect = () => (
  <div className={styles.root}>
    <Heading level={4} className={styles.title}>
      <T name="citizen_membership_guide_nft_title" />
    </Heading>
    <Carousel className={styles.carousel} {...defaultCarouselProps}>
      <SwiperSlide>
        <BaseCard className={classNames(cardStyles.card, styles.card)}>
          <img src={basket} alt="basket" className={cardStyles.image} width={120} height={120} />
          <div className={cardStyles.content}>
            <Heading level={5} className={cardStyles.title}>
              <T name="citizen_menu_marketplace" />
            </Heading>
            <p className={cardStyles.description}>
              <T name="citizen_membership_guide_nft_card1_desc" balance />
            </p>
          </div>
          <a
            href={`${import.meta.env.VITE_CITIZEN_STORE_URL}/marketplace`}
            className={cardStyles.action}>
            <T name="citizen_button_title_go_marketplace" />
          </a>
        </BaseCard>
      </SwiperSlide>
      <SwiperSlide>
        <BaseCard className={classNames(cardStyles.card, styles.card)}>
          <img src={rocket} alt="rocket" className={cardStyles.image} width={120} height={120} />
          <div className={cardStyles.content}>
            <Heading level={5} className={cardStyles.title}>
              <T name="citizen_adventure_title" />
            </Heading>
            <p className={cardStyles.description}>
              <T name="citizen_membership_guide_nft_card2_desc" balance />
            </p>
          </div>
          <Link to="/adventure" className={cardStyles.action}>
            <T name="JOIN_ADVENTURE" />
          </Link>
        </BaseCard>
      </SwiperSlide>
      <SwiperSlide>
        <BaseCard className={classNames(cardStyles.card, styles.card)}>
          <img src={coneHat} alt="cone hat" className={cardStyles.image} width={120} height={120} />
          <div className={cardStyles.content}>
            <Heading level={5} className={cardStyles.title}>
              <T name="citizen_membership_guide_nft_card3_title" />
            </Heading>
            <p className={cardStyles.description}>
              <T name="citizen_membership_guide_nft_card3_desc" balance />
            </p>
          </div>
          <Link className={cardStyles.action} to="/support/notice?category=event">
            <T name="citizen_button_title_check_event" />
          </Link>
        </BaseCard>
      </SwiperSlide>
    </Carousel>
  </div>
);
